import {Component, input, output} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

interface BackdropPointerInteraction {
    pointerId: number;
    startedOnBackdrop: boolean;
    endedOnBackdrop: boolean;
    pointerUpReceived: boolean;
}

@Component({
  selector: 'app-dialog',
  standalone: true,
    imports: [ NgOptimizedImage ],
  templateUrl: './app-dialog.component.html',
  styleUrl: './app-dialog.component.scss'
})
export class AppDialogComponent {
    readonly subtitle = input.required<string>();
    readonly hideIcon = input(false);
    readonly close = output<void>();

    private pointerInteraction: BackdropPointerInteraction | null = null;

    closeDialog(): void {
        this.close.emit();
    }

    onBackdropPointerDown(event: PointerEvent): void {
        const interaction = this.pointerInteraction;
        if (interaction && !interaction.pointerUpReceived && interaction.pointerId !== event.pointerId) {
            return;
        }
        this.pointerInteraction = {
            pointerId: event.pointerId,
            startedOnBackdrop: event.target === event.currentTarget,
            endedOnBackdrop: false,
            pointerUpReceived: false,
        };
    }

    onBackdropPointerUp(event: PointerEvent): void {
        const interaction = this.pointerInteraction;
        if (!interaction || event.pointerId !== interaction.pointerId) {
            return;
        }
        interaction.endedOnBackdrop = event.target === event.currentTarget;
        interaction.pointerUpReceived = true;

        if (!interaction.startedOnBackdrop && !interaction.endedOnBackdrop) {
            this.resetBackdropPointerState();
        }
    }

    onBackdropPointerCancel(event: PointerEvent): void {
        if (event.pointerId === this.pointerInteraction?.pointerId) {
            this.resetBackdropPointerState();
        }
    }

    onBackdropClick(event: MouseEvent): void {
        const interaction = this.pointerInteraction;
        if (!interaction?.pointerUpReceived) {
            return;
        }
        const isBackdropClick =
            interaction.startedOnBackdrop &&
            interaction.endedOnBackdrop &&
            event.target === event.currentTarget;

        this.resetBackdropPointerState();

        if (isBackdropClick) {
            this.closeDialog();
        }
    }

    private resetBackdropPointerState(): void {
        this.pointerInteraction = null;
    }
}
